import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { fromPromise } from 'rxjs/internal-compatibility';
import { catchError, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class ImageSrcService {
  private cache: Record<string, BehaviorSubject<string>> = {};
  private http: HttpClient;

  constructor() {
    this.http = inject(HttpClient);
  }

  public loadImage(imageSrc: string, withCache?: boolean): Observable<string> {
    if (withCache) {
      if (this.cache[imageSrc] === undefined) {
        this.cache[imageSrc] = new BehaviorSubject<string>('');
      } else {
        return this.cache[imageSrc];
      }
    }

    return this.http.get(imageSrc, { responseType: 'blob' })
      .pipe(
        switchMap(avatarSrc => fromPromise(new Promise<string>(resolve => {
          const reader = new FileReader();
          reader.addEventListener('load', () => {
            const imageBinary = reader.result as string;
            resolve(imageBinary);
          });

          if (avatarSrc) {
            reader.readAsDataURL(avatarSrc);
          }
        }))),
        catchError(() => of('')),
        tap(res => {
          if (withCache) {
            this.cache[imageSrc].next(res);
          }
        }),
      );
  }
}
